import { gql } from 'apollo-boost';

export const accountMutation = gql`mutation myAccountSet(
  $id: Int!,
  $name: String!,
  $ein: String,
  $website: String,
  $missionStatement: String,
  $officeLocation: String,
  $locationLat: Float,
  $locationLng: Float,
  $woman: Boolean,
  $personOfColor: Boolean,
  $numberOfWomen: Int,
  $numberOfpeopleOfColor: Int,
  $totalNumber: Int
  ) {
  myAccountSet(input: {
    id: $id,
    name: $name,
    ein: $ein,
    website: $website,
    missionStatement: $missionStatement,
    officeLocation: $officeLocation,
    locationLat: $locationLat,
    locationLng: $locationLng,
    woman: $woman,
    personOfColor: $personOfColor,
    numberOfWomen: $numberOfWomen,
    numberOfpeopleOfColor: $numberOfpeopleOfColor,
    totalNumber: $totalNumber
  }) {
    error
  }
}`;

export const logoMutation = gql`mutation AccountLogo($type: String!, $logo: Upload!) {
  uploadLogo(logoType: $type, logo: $logo) {
    success
    id
  }
}`;


export const deleteLogoMutation = gql`
  mutation deleteAccountLogo($id: Int!) {
    deleteAccountLogo(id: $id) {
      success
    }
  }
`;


export const deleteUserLogoMutation = gql`
  mutation deleteUserLogo($id: Int!) {
    deleteUserLogo(id: $id) {
      success
    }
  }
`;
